import roller from 'common/module/ui/roller';
import loadEmbed from 'common/tools/ui/load-embed';

import applicationBootstrap from 'website/bootstrap';
import { socialActionsBootstrap } from 'website/bootstrap/socialActionsBootstrap';
import diaporama from 'website/containers/slideshow/slideshow';
import userRating from 'website/containers/user-action/userRating';
import userWantToSee from 'website/containers/user-action/userWantToSee';
import affinitySuggestions from 'website/containers/user/affinitySuggestions';
import loadAdgage from 'website/module/advertisement/adgage';
import loadMgid from 'website/module/advertisement/mgid';
import loadOutbrain from 'website/module/advertisement/outbrain';
import loadTaboola from 'website/module/advertisement/taboola';
import emergenceBanner from 'website/module/emergence/banner-bottom';
import initPlayer from 'website/module/player';
import facebookWidgets from 'website/module/ui/facebookWidgets';
import initMoreTriggerOverlay from 'website/module/ui/more-trigger-overlay';
import selectChange from 'website/module/ui/select-change';

// bootstrap the application / store
applicationBootstrap().then(() => {
  initPlayer();
  diaporama();

  loadEmbed();

  loadOutbrain();

  loadAdgage();

  loadTaboola();

  loadMgid();

  facebookWidgets();

  initMoreTriggerOverlay();

  userRating();

  roller();

  selectChange();

  emergenceBanner();

  userWantToSee();
  affinitySuggestions();
  socialActionsBootstrap();
});
